app.controller('RegisterCtrl', ['$rootScope','$scope', '$routeParams', '$http', '$window', '$q', 'appFactory', '$uibModal',
function ($rootScope, $scope, $routeParams, $http, $window, $q, appFactory, $uibModal) {

    $rootScope.user = {};
    $scope.ListSales = [];
    $scope.ListOffice = [];

    $scope.ConfirmPassword = '';
    $scope.user.PhoneCode = '+62';

    $scope.user.Location = window.location.href;
    //$scope.user.atEmail = '@';
    //$scope.user.EmailDomain = 'other'
    //$scope.user.QuestionRDN = '1';

    $scope.disablesales = false;
    $scope.disableReferalNumber = false;
    $scope.SalesSelected = '';

    $scope.disableOffice = false;
    $scope.OfficeSelected = '';

    $scope.showPassword = false;
    $scope.inputType = 'password';
    $scope.toggleShowPassword = function () {
        $scope.showPassword = !$scope.showPassword;
        if ($scope.inputType == 'password')
            $scope.inputType = 'text';
        else
            $scope.inputType = 'password';
    }

    $scope.showPasswordConfirmation = false;
    $scope.inputTypeConfirmation = 'password';
    $scope.toggleShowPasswordConfirmation = function () {
        $scope.showPasswordConfirmation = !$scope.showPasswordConfirmation;
        if ($scope.inputTypeConfirmation == 'password')
            $scope.inputTypeConfirmation = 'text';
        else
            $scope.inputTypeConfirmation = 'password';
    }
    $scope.checkPassword = function () {
        if ($scope.ConfirmPassword != $scope.user.Password) {
            $scope.formRegister.txtConfirmPassword.$invalid = true;
            $scope.infolengthpass = false;
        }
    };

    $scope.bo = function () {


        var SWALtranslate = $scope.SWALtranslate('beneficialowner');

        Swal.fire({
            text: SWALtranslate.message,
            imageAlt: 'BO',
            imageHeight: 250,
            animation: false,
            customClass: {
                confirmButton: 'swal-confirm-button-class',
            },
        });

    }

    //$scope.EmailDomainChange = function () {
    //        $scope.user.Email = '';
    //}

    $scope.page = 'step1';

    $scope.Office = function () {
        $scope.user.Office = $scope.user.Sales;
    }

    var allPromise = $q.all([
        appFactory.getData(`/service/client.svc/GetCountryPhone`).then(function (data) {

            if (data.status == 200)
                $scope.ListCountryPhone = data.data.d;
        }),
        appFactory.getData(`/service/client.svc/GetCIFSales`).then(function (data) {

            if (data.status == 200) {
                //const filteredData = data.data.d.filter(item => item.SalesCode !== "SBY68");
                //$scope.ListSales = filteredData;
                $scope.ListSales = data.data.d;
            }
            
        }),
         appFactory.getData(`/service/client.svc/GetCIFOffice`).then(function (data) {

             if (data.status == 200)
                 $scope.ListOffice = data.data.d;
         }),
         appFactory.getData(`/service/client.svc/GetCIFBank`).then(function (data) {

             if (data.status == 200)
                 $scope.ListBank = data.data.d;
         }),

    ]);

    allPromise.then(function () {

    });

    // when sales is selected
    $scope.selectSales = function (item, model, label, event) {
        if (item.SalesPersonID) {
            $scope.user.Sales = item.SalesPersonID;
            $scope.SalesSelected = item;
            console.log("SalesSelected3", $scope.SalesSelected)
        }
    };

    $scope.selectOffice = function (item, model, label, event) {
        if (item.OfficeNID) {
            $scope.user.Office = item.OfficeNID;
            $scope.OfficeSelected = item;
        }

    };

    $scope.checkReferral = function () {
        console.log($scope.user.ReferalNumber);
        if ($scope.user.ReferalNumber == 'GSM') {
            appFactory.getData(`/service/client.svc/GetAliasSales?alias=SBY68`).then(function (data) {

                if (data.status == 200) {

                    // jika id sales di temukan maka:
                    if (data.data.d.SalesPersonID) {

                        $scope.SalesSelected = data.data.d;
                        console.log("SalesSelected", $scope.SalesSelected)
                        console.log("SalesCode", $scope.SalesSelected.SalesCode)
                        $scope.disablesales = true;
                    }
                }
            });
        } else {
            $scope.disablesales = false;
        }
    }

    $scope.checkEmail = function () {
        if ($scope.user.Email) {

            appFactory.getData(`/service/client.svc/checkemail?email=${$scope.user.Email}`).then(function (data) {

                if (data.status == 200) {

                    if (data.data.d != null) {
                        var obj = data.data.d;
                        if (obj.risk == 'high' || obj.risk == 'unknown') {
                            $scope.user.Email = '';
                            swal.fire('Gagal', obj.message, "error");
                        } else {
                            swal.fire('Success', obj.message, 'success');
                        }
                    }
                }
            });
        }
    }

    // check bank number duplication
    $scope.checkBankNumber = function () {
        if ($scope.user.BankNumber) {

            appFactory.getData(`/service/client.svc/checkBankNumber?BK=${$scope.user.BankNumber}`).then(function (data) {

                if (data.status == 200) {

                    if (data.data.d != null) {
                        var obj = data.data.d;
                        if (obj.key && obj.key == 2) {
                            $scope.user.BankNumber = '';
                            Swal.fire('Failed', obj.value, "error");
                        }
                    }
                }
            });
        }
    }

    // jika url ke: register/{id sales} maka sales selected auto
    if ($routeParams.id) {

        if ($routeParams.id == 'ILSANG') {
            $scope.user.ReferalNumber = "ILSANG";
            appFactory.getData(`/service/client.svc/GetAliasSales?alias=VAS67`).then(function (data) {

                if (data.status == 200) {

                    // jika id sales di temukan maka:
                    if (data.data.d.SalesPersonID) {

                        $scope.SalesSelected = data.data.d;
                        console.log("SalesSelected", $scope.SalesSelected)
                        console.log("SalesCode", $scope.SalesSelected.SalesCode)
                        $scope.disablesales = true;
                    }
                }
            });
            $scope.disableReferalNumber = true;
        }
        else if ($routeParams.id == 'PBR68-D12') {
            //$scope.user.ReferalNumber = "ILSANG";
            appFactory.getData(`/service/client.svc/GetAliasSales?alias=PBR68-D12`).then(function (data) {

                if (data.status == 200) {

                    // jika id sales di temukan maka:
                    if (data.data.d.SalesPersonID) {

                        $scope.SalesSelected = data.data.d;
                        console.log("SalesSelected", $scope.SalesSelected)
                        console.log("SalesCode", $scope.SalesSelected.SalesCode)
                        $scope.disablesales = true;
                    }
                }
            });
            //$scope.disableReferalNumber = true;
        }
        else if ($routeParams.id == 'ALLAN') {
            $scope.user.ReferalNumber = "ALLAN";
            $scope.disableReferalNumber = true;

        }
        else if ($routeParams.id == 'RAMA') {
            $scope.user.ReferalNumber = "RAMA";
            $scope.disableReferalNumber = true;
        }
        else if ($routeParams.id == 'BAKBAK') {
            $scope.user.ReferalNumber = "BAKBAK";
            $scope.disableReferalNumber = true;
        }
        else if ($routeParams.id == 'JCIEJ') {
            $scope.user.ReferalNumber = "JCIEJ";
            appFactory.getData(`/service/client.svc/GetAliasSales?alias=SBY68`).then(function (data) {

                if (data.status == 200) {

                    // jika id sales di temukan maka:
                    if (data.data.d.SalesPersonID) {

                        $scope.SalesSelected = data.data.d;
                        console.log("SalesSelected", $scope.SalesSelected)
                        console.log("SalesCode", $scope.SalesSelected.SalesCode)
                        $scope.disablesales = true;
                    }
                }
            });
            $scope.disableReferalNumber = true;
        }
        else {
            appFactory.getData(`/service/client.svc/GetAliasSales?alias=${$routeParams.id}`).then(function (data) {

                if (data.status == 200) {

                    // jika id sales di temukan maka:
                    if (data.data.d.SalesPersonID) {

                        $scope.SalesSelected = data.data.d;
                        console.log("SalesSelected", $scope.SalesSelected)
                        console.log("SalesCode", $scope.SalesSelected.SalesCode)
                        //if ($scope.SalesSelected.SalesCode == "VAS67" && $routeParams.id != 'ILSANG') {
                        //    $scope.user.ReferalNumber = "Enggit Glory";
                        //    $scope.disableReferalNumber = true;
                        //}

                        $scope.disablesales = true;
                    }
                }
            });
        }
    }

    // variables before submit post
    $scope.prepareData = function () {

        //if (!$scope.user.Sales && !$scope.user.Office) {
        //    $scope.user.Office = $scope.Office;
        //}

        //if ($scope.user.Sales != "" && $scope.user.Office == null) {
        //    $scope.user.Office = $scope.Office;
        //}
        if ($routeParams.id) {
            $scope.user.Sales = $scope.SalesSelected.SalesPersonID
            //if ($scope.SalesSelected.SalesPersonID == "33789") {
            //    $scope.user.ReferalNumber = "Enggit Glory";
            //}
           
        }

        $scope.user.ClientNCategory = 21;


        if ($scope.user.Office == null) {
            $scope.user.Office = 1;
        }

        
       
    }

    $scope.modalOTP = function () {
        //let message = tipe;
        let url = 'ModalOTP.html';
        let ctrl = 'OTPController';

        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: url,
            controller: ctrl,
            size: 'md',
            resolve: {
                items: function () {
                    return $scope.user.Email;
                }
            }
        });

        modalInstance.result.then(function (resolvedResponse) {
            $window.location.href = "#/login";
        }, function () { });
    }

    $scope.submit = function () {
        $scope.prepareData();

      
        var challenge = grecaptcha.getResponse();
        if (!challenge) {
            alert("Mohon ulangi centang captcha");
            return false;
        }
        else {
            $scope.user.challenge = challenge
        }


        var urlsvc = '/service/client.svc/RegistrasiUser'; // 1
        if ($scope.user.QuestionRDN == 1) {
            var preconfirmtranslate = "submitregistrationconf"; // 2
        }
        if ($scope.user.QuestionRDN == 2) {
            var preconfirmtranslate = "submitregistrationconfo"; // 2
        }
        if ($scope.user.QuestionRDN == 3) {
            var preconfirmtranslate = "submitregistrationconfo"; // 2
        }
        var postData = { User: $scope.user } // 3
        var method = "POST" // 4

        if ($scope.SalesSelected) {
            Swal.fire({
                icon: 'question',
                title: 'Apakah anda yakin memilih kode sales ini ?',
                html: 'Nama : ' + $scope.user.FirstName +
                        '</br>Sales : ' + $scope.SalesSelected.SalesCode +
                        '</br></br>' +
                        '<p style="color:red">*Pastikan sales yang anda pilih sudah sesuai</p>',
                showCancelButton: true,
                confirmButtonColor: '#dc3545',
                confirmButtonText: 'Submit',
                showLoaderOnConfirm: true,
                preConfirm: (preConf) => {
                    $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (data) {
                        if (data)
                            $window.location.href = "#/login";
                    });
                }
            })
        } else {
            Swal.fire({
                icon: 'question',
                title: 'Tidak ada kode sales yang dipilih',
                text: 'Apakah anda yakin tidak memilih kode sales ?',
                showCancelButton: true,
                confirmButtonColor: '#dc3545',
                confirmButtonText: 'Submit',
                showLoaderOnConfirm: true,
                preConfirm: (preConf) => {
                    $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (data) {
                        if (data)
                            $window.location.href = "#/login";
                    });
                }
            })
        }
    }
}]);
